import { Binder } from '@ribajs/core'
import { ResponsiveIframeService } from '../services/index.js'

import type { ResponsiveIframeSettings } from '../types/index.js'

/*
 * Similar to `IframeResizerBinder` but based on https://github.com/npr/responsiveiframe
 */
export class ResponsiveIframeIframeResizerBinder extends Binder<
  ResponsiveIframeSettings,
  HTMLIFrameElement
> {
  static key = 'responsive-iframe'

  responsiveIframe?: ResponsiveIframeService

  async bind() {
    //
  }

  async routine(el: HTMLIFrameElement, options: ResponsiveIframeSettings = {}) {
    if (this.responsiveIframe) {
      this.unbind()
    }
    this.responsiveIframe = new ResponsiveIframeService(el, options)
  }

  unbind() {
    if (this.responsiveIframe) {
      this.responsiveIframe.destroy()
    }
  }
}
